import ProductTemplateSimple from "../templates/product-template-simple";
import { Eaton } from '../data/products'
function ProductEaton() {
    return (
        <>
            <ProductTemplateSimple data = {Eaton}/>
        </>
    )
}

export default ProductEaton;